
import { connect } from 'react-redux';

import { calculateThunk } from '../ArkaneResult/calculateThunk';
import { updateBirthDay } from '../../app/store/userReducer';
import { updateBirthMonth } from '../../app/store/userReducer';
import { updateBirthYear } from '../../app/store/userReducer';

import Date from './Date';

let mapStateToProps = (state, ownProps) => ({
    routeName: state.router.routeName,
    birthDayInput: state.user.birthDayInput,
    birthMonthInput: state.user.birthMonthInput,
    birthYearInput: state.user.birthYearInput,
});

let mapDispatchToProps = (dispatch) => ({
    onChangeBirthDay: (e, cb=null) => {
        dispatch(updateBirthDay(e.target.value, cb));
    },
    onChangeBirthMonth: (e, cb=null) => {
        dispatch(updateBirthMonth(e.target.value, cb));
    },
    onChangeBirthYear: (e, cb=null) => {
        dispatch(updateBirthYear(e.target.value));
    },
    onCalculate: () => {
        //console.log('e.target.value');
        dispatch(calculateThunk());
    },
});

const DateContainer = connect(mapStateToProps, mapDispatchToProps)(Date);

export default DateContainer;
